import React, { useCallback } from 'react';

import i18n from '@nextroll/ar-i18n';

import { ExpandablePanel } from './ExpandablePanel';


export const ExpandablePanelContactInfoFilter = ({ filters, setFilters }: {
    filters: string[];
    setFilters: (filters: string[]) => void;
}) => {
    const handleCheck = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.checked) {
            setFilters(['checked']);
            return;
        }
        setFilters([]);
    }, [setFilters]);

    return (
        <ExpandablePanel
            title={i18n.gettext('Contact Info')}
            icon={<i className='fas fa-phone' />}
            items={filters}
            setItems={setFilters}
        >
            <span>
                <input
                    type='checkbox'
                    id='filter-contact-info-checkbox'
                    name='filter-contact-info-checkbox'
                    checked={filters.includes('checked')}
                    onChange={handleCheck}
                    className='ar-checkbox'
                />
                <label htmlFor='filter-contact-info-checkbox'>
                    {i18n.gettext('Has mobile number OR direct number')}
                </label>
            </span>
        </ExpandablePanel>
    );
};
